import { atom, PrimitiveAtom } from 'jotai'

import { store } from '@/store'
import { INotification, TToastStatus } from '@/types/gigiChat/Notifications'

export const notificationAtom: PrimitiveAtom<INotification> = atom<INotification>({
    message: null,
    status: 'success',
})

export const addNotification = (status: TToastStatus, message: string | React.ReactNode) => {
    store.set(notificationAtom, { status, message })
}
